import { Instance, types } from 'mobx-state-tree';
import { BatchClassBatchSubjectConfiguration } from './BatchClassBatchSubjectConfiguration';
import { BatchClassBatchSubjectExtraSlot } from './BatchClassBatchSubjectExtraSlot';

export const BatchClass = types.model('BatchClassModel', {
  id: types.string,
  name: types.string,
  batch_class_batch_subject_configurations: types.optional(types.array(BatchClassBatchSubjectConfiguration), []),
  batch_class_batch_subject_extra_slot: types.optional(types.array(BatchClassBatchSubjectExtraSlot), []),
});

export type BatchClassModelType = Instance<typeof BatchClass>;
